"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _Icon = _interopRequireDefault(require("@mui/material/Icon"));
var _styles = require("@mui/material/styles");
/**
 * @ignore - internal component.
 */
var HiPrivate = (0, _pure.default)(function (props) {
  var theme = (0, _styles.useTheme)();
  var _props$color = props.color,
    color = _props$color === void 0 ? props.color || theme.palette.neutral.main : _props$color,
    style = props.style,
    other = (0, _objectWithoutProperties2.default)(props, ["color", "style"]);
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    style: (0, _objectSpread2.default)({}, style, {
      fontSize: props.size || 16
    }),
    color: props.color || theme.palette.neutral.main
  }, other), /*#__PURE__*/_react.default.createElement("svg", {
    id: "private",
    "data-name": "private",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 275.3 360.62"
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: "cls-1",
    d: "M240.68,120.74q14.49,0,24.15,9.66t10.47,24.15V326.81q-.81,14.49-10.47,24.15t-24.15,9.66H34.61q-14.49,0-24.15-9.66T0,326.81V154.55q.8-14.49,10.46-24.15t24.15-9.66H51.52V86.13q.79-36.22,25.35-60.77T137.65,0q36.22.81,60.77,25.36t25.36,60.77v34.61Zm-103-86.13q-21.74.81-36.22,15.3T86.13,86.13v34.61h103V86.13q-.82-21.73-15.3-36.22T137.65,34.61Zm0,240.69q14.49-.8,24.15-10.47t9.66-24.15q0-14.49-9.66-24.15t-24.15-9.65q-14.49,0-24.15,9.65t-9.66,24.15q0,14.49,9.66,24.15T137.65,275.3Z",
    fill: color
  })));
});
HiPrivate.muiName = 'SvgIcon';
var _default = exports.default = HiPrivate;